import Flickity from 'flickity/dist/flickity.pkgd.min';
import Choices from 'choices.js/public/assets/scripts/choices';
import Plyr from 'plyr/dist/plyr.min';
import tippy from 'tippy.js';
export default {
  init() {
    // var select = document.querySelector('.custom-select');
    if (document.querySelectorAll('.custom-select').length > 0) {
      const choices = new Choices('.custom-select', {
        searchEnabled : false,
      });
      choices;
    }

    // window.ajaxurl = 'http://localhost:3000/wp-admin/admin-ajax.php';
    window.ajaxurl = 'https://test.asiaambgracia.com/wp-admin/admin-ajax.php';

    const ajaxurl = window.ajaxurl;

    var player = new Plyr('.video', {
      controls: ['play-large'],
      autoplay: false,
      autopause: false,
      captions: { active: false },
      loop: { active: true },
      playsinline: true,
      clickToPlay: true,
      debug: false,
      hideControls: true,
      volume: 0,
      muted: true,
      // iconUrl: 'http://localhost:3000/wp-content/themes/dr-theme/dist/images/video/plyr.svg',
      // iconUrl: 'https://davidrajadel.com/wp-content/themes/drajadel/dist/images/video/plyr.svg',
    });
    if(document.querySelectorAll('.video').length > 0) {
      player.volume = 0;
      player;
    }

    const on = (selector, eventType, childSelector, eventHandler) => {
      const elements = document.querySelectorAll(selector);
      
      elements.forEach(element => {
        element.addEventListener(eventType, eventOnElement => {
          if (eventOnElement.target.matches(childSelector)) {
            eventHandler(eventOnElement)
          }
        })
      });
    }

    var sidebar = document.querySelector('.sidebar');
    var sidebarCart = document.querySelector('.sidebar--cart .shopping-cart--resume');

    if (sidebar) {
      var menus = sidebar.querySelectorAll('.menu__item');

      menus.forEach(elem => {
        elem.addEventListener('click', function () {
          menus.forEach(menu => {
            menu.classList.remove('selected');
          })
          elem.classList.toggle('selected');
        })
      });
    }

    window.setCookie = (cname, cvalue, exdays) => {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    window.deleteAllCookies = () => {
      var allCookies = document.cookie.split(';');
      var xhr = new XMLHttpRequest();
      var formData = new FormData();

      for (var i = 0; i < allCookies.length; i++) {
        var cookie = allCookies[i].split('=')[0];
        window.setCookie(cookie, '', 0);
      }

      formData.append("action", "clear_cart");
      xhr.open("POST", ajaxurl);
      xhr.send(formData);

      // xhr.onloadend = () => {
      //   if (xhr.status == 200) {
      //     location.href = document.querySelector('.header .logo').getAttribute('href');
      //   }
      // }
    }

    window.getCookie = (cname) => {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    window.refreshCart = function (getTotal, getNumber) {
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      var counters = document.querySelectorAll('.counter');

      formData.append("action", "get_cart");
      formData.append("getTotal", getTotal);
      formData.append("getNumber", getNumber);
      xhr.open("POST", ajaxurl);
      xhr.send(formData);

      xhr.onloadend = () => {
        if (xhr.status == 200) {
          var cart = JSON.parse(xhr.response);
          
          if(getTotal) {
            counters.forEach(counter => {
              counter.innerHTML = cart.number;
            });
          } else if(getNumber) {
            document.querySelector('.sidebar--cart .cart-total').innerHTML = cart.total;
          } else {
            counters.forEach(counter => {
              counter.innerHTML = cart.number;
            });
            document.querySelector('.sidebar--cart .cart-total').innerHTML = cart.total;
            sidebarCart.innerHTML = cart.cart;
            
          }
        }
      }
    }

    window.schedule = JSON.parse(window.getCookie('schedule'));

    window.addEventListener("load", () => {
      // var session = window.getCookie('user_type');
      var menu = document.querySelector('.sidebar--mobile');
      var menuDesktop = document.querySelector('.sidebar--menu');
      var resume = document.querySelector('.shopping-cart');
      var resumeTrigger = document.querySelector('.resume-trigger');
      var roleTrigger = document.querySelector('.role-trigger');
      var popupRole = document.querySelector('.popup--role');
      var popups = document.querySelectorAll('.popup');
      var menuMobile = document.querySelector('.menu--secondary');
      
      if (menuMobile) {
        var sub = menuMobile.querySelectorAll('.has-children');
      }
      var tooltips = document.querySelectorAll('.tooltip__wrapper');

      if (tooltips) {
        tooltips.forEach(tooltip => {
          var trigger = tooltip.querySelector('.tooltip-trigger');
          var desc = tooltip.querySelector('.tooltip');

          setTimeout(() => {
            trigger.addEventListener('click', function (e) {
              e.preventDefault();
              desc.classList.toggle('visible');
            })
          }, 1000);
        });
      }
      
      
      // if ( session !== '') {
      //   console.log('user set');
      // } else {
      //   window.deleteAllCookies();
      // }

      if(menuDesktop) {
        var items = menuDesktop.querySelectorAll('[data-slug]');

        items.forEach(item => {
          if (location.pathname.includes(item.getAttribute('data-slug'))) {
            item.classList.add('selected');
          }
        });
      }

      if(resumeTrigger || resume) {
        resumeTrigger.addEventListener('click', () => {
          resume.classList.toggle('visible');
          resumeTrigger.classList.toggle('selected');
        })
      }

      if (roleTrigger) {
        roleTrigger.addEventListener('click', () => {
          document.querySelector('.popup--role').classList.toggle('opened');
          document.querySelector('body').classList.add('fixed');
        })
      }

      if(popupRole) {
        popupRole.querySelector('.change-role').addEventListener('click', () => {
          localStorage.clear();
          sessionStorage.clear();
          window.deleteAllCookies();
          setTimeout(() => {
            location.href = document.querySelector('.header .logo').getAttribute('href');
          }, 300);
        })
      }

      if(popups.length > 0) {
        popups.forEach(popup => {
          var close = popup.querySelector('.popup__closer');
          var extend = popup.querySelector('.button__wrapper .update-session');
          var back = popup.querySelector('.button__wrapper .back');

          if(close) {
            close.addEventListener('click', () => {
              popup.classList.toggle('opened');
              document.querySelector('body').classList.remove('fixed');
            })
          }

          if(extend) {
            extend.addEventListener('click', () => {
              var location = localStorage.getItem('user_delivery');
              window.setCookie("user_type", location, 1 / 24);
              popup.classList.toggle('opened');
            })
          }

          if(back) {
            back.addEventListener('click', () => {
              localStorage.clear();
              sessionStorage.clear();
              window.deleteAllCookies();
              setTimeout(() => {
                location.href = document.querySelector('.header .logo').getAttribute('href');
              }, 300);
            })
          }
        });
      }

      if(menu) {
        var carta = new Flickity('.sidebar--mobile .menu__wrapper', {
          imagesLoaded: true,
          autoPlay: 3000,
          percentPosition: false,
          cellAlign: 'left',
          contain: true,
          hash: false,
          selectedAttraction: 0.01,
          friction: 0.3,
          cellSelector: '.menu__item',
          watchCSS: true,
          freeScroll: true,
          freeScrollFriction: 0.03,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
        });
        carta;
      }

      if (menuMobile) {
        sub.forEach(su => {
          var subwrapper = su.querySelector('.submenu__wrapper');
          var trigger = su.querySelector('.title--trigger');
  
          trigger.addEventListener('click', () => {
            subwrapper.classList.toggle('visible');
            trigger.classList.toggle('opened');
          })
        });
  
        document.querySelector('.header__wrapper.mobile .header__actions .nav__wrapper').addEventListener('click', () => {
          menuMobile.classList.toggle('visible');
        });

        document.querySelector('.header__wrapper .header__actions .nav__wrapper .icon').addEventListener('click', () => {
          menuMobile.classList.toggle('visible');
        });
  
        menuMobile.querySelector('.close').addEventListener('click', () => {
          menuMobile.classList.toggle('visible');
        });
      }
    })

    if (sidebarCart) {

      on('.shopping-cart', 'click', '.qty--plus', (e) => {
        var xhr = new XMLHttpRequest();
        var formData = new FormData();
        var element = e.target;
        var trigger = element.closest('.js--qty');
        var hash = trigger.getAttribute('data-hash');
        var qty = trigger.querySelector('.qty');

        formData.append("action", "changeCartItemQuantity");
        formData.append("hash", hash);
        formData.append("quantity", Number(qty.value) + 1);
        xhr.open("POST", ajaxurl);
        xhr.send(formData);

        xhr.onloadend = () => {
          if (xhr.status == 200) {
            window.refreshCart(false, false);
          }
        }
      })

      on('.shopping-cart', 'click', '.qty--minus', (e) => {
        var xhr = new XMLHttpRequest();
        var formData = new FormData();
        var element = e.target;
        var trigger = element.closest('.js--qty');
        var hash = trigger.getAttribute('data-hash');
        var qty = trigger.querySelector('.qty');

        formData.append("action", "changeCartItemQuantity");
        formData.append("hash", hash);
        formData.append("quantity", Number(qty.value) - 1);
        xhr.open("POST", ajaxurl);
        xhr.send(formData);

        xhr.onloadend = () => {
          if (xhr.status == 200) {
            window.refreshCart(false, false);
          }
        }
      })
    }

    window.addEventListener('load', () => {
      tippy(document.querySelectorAll('[data-tippy-content]'), {
        allowHTML: true,
        appendTo: 'parent',
        placement: 'bottom',
      });
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js